import { where } from "firebase/firestore";
import { getRevendaIdByPark } from '../../config/auth';
import { Collection, WhereField } from '../../shared/constants';
import { addDoc, deleteDoc, getAllDocs, getAllDocsByQueries, getAllDocsByRevendaId, getDocById, updateDoc } from './collectionBaseWorker';

export const getAllLicencePlan = async () => {
    return await getAllDocsByRevendaId({ collection: Collection.NEW_PLAN_LICENCE, revendaId: getRevendaIdByPark() })
}

export const getAllLicencePlansByAssociatedRessales = async ({ associatedResales }) => {
    const items = await getAllDocs({ collection: Collection.NEW_PLAN_LICENCE })
    return items.filter(e => associatedResales.map(e => e.value).includes(e.revendaId)).sort((a, b) => b.revendaId.localeCompare(a.revendaId))
}

export const getAllPublicLicencePlan = async () => {
    const result = await getAllDocsByQueries({
        collection: Collection.NEW_PLAN_LICENCE,
        queries: [
            where(WhereField.TIPO, "==", 'publico'),
            where(WhereField.STATUS, "==", 'ativo'),
            where(WhereField.REVENDAID, "==", getRevendaIdByPark())
        ]
    })
    return result.sort((a, b) => a.ordem - b.ordem)
}

export const getFirstHighlightPlan = async () => {
    const result = await getAllDocsByQueries({
        collection: Collection.NEW_PLAN_LICENCE,
        queries: [
            where(WhereField.TIPO, "==", 'publico'),
            where(WhereField.STATUS, "==", 'ativo'),
            where(WhereField.REVENDAID, "==", getRevendaIdByPark()),
            where(WhereField.DESTAQUE, "==", 'sim')
        ]
    })
    return result.sort((a, b) => a.ordem - b.ordem)
}

export const getLicencePlanById = async ({ id }) => {
    return await getDocById({ collection: Collection.NEW_PLAN_LICENCE, id: id })
}

export const addLicencePlan = async ({ data }) => {
    const doc = await addDoc({ collection: Collection.NEW_PLAN_LICENCE, data: data })
    return doc.id;
}

export const updateLicencePlan = async ({ id, data }) => {
    await updateDoc({ collection: Collection.NEW_PLAN_LICENCE, id: id, data: data })
}

export const deleteLicencePlan = async ({ id }) => {
    await deleteDoc({ collection: Collection.NEW_PLAN_LICENCE, id: id })
}